import { onAway, onClose, onFull, onJoined, onLeft, onPos, onWelcome } from '../../2-controllers/core/server-messages';
import { AV } from '../media/meeting/av';
import { Sfu } from '../media/meeting/sfu';
import { startAv } from '../media/meeting/start';
import { addChat, bindMine, onReact } from '../screen/meeting/chat';
import { dropBubble } from '../../3-store/meeting/chat';
import { LINK } from '../../3-store/core/peers';
import { onMeet, onPub } from '../../2-controllers/meeting/peers';
import { onCls, resetClass } from '../../2-controllers/meeting/classroom';
import type { ServerOf, ServerT } from '../../../shared/protocol';

// 서버 메시지 종류 t → 처리. 메시지 형식은 shared/protocol.ts (close는 서버가 아니라 net.ts가 연결이 끊길 때 부른다).
// 이 표가 바깥(서버)과 닿는 접점이다: 상태 변경은 2-controllers의 함수에 맡긴다. core는 meeting을 모르므로 한 메시지를 core → meeting 순서로 이 표가 이어서 부른다.
export const NET_ON: { [T in ServerT]?: (m: ServerOf<T>) => void } & { close?: (m: { fails: number }) => void } = {
  welcome(m) { onWelcome(m); resetClass(); startAv(m.id); },   // core의 처리 다음에 발언권을 비우고(새 접속에는 없다) 영상 연결을 시작한다
  joined: onJoined,
  left(m) { onLeft(m); AV.drop(m.id); dropBubble(m.id); },
  pos: onPos,
  away: onAway,
  meet: onMeet,
  cls: onCls,   // 강사가 발언권을 주고 거둔다
  chat(m) { if (m.id !== LINK.id) addChat(m.id, m.name, m.text, false, m.mid); else bindMine('chat', String(m.text), m.mid); },
  img(m) { if (m.id !== LINK.id) addChat(m.id, m.name, '[사진]', false, m.mid, { data: m.data }); else bindMine('img', m.data, m.mid); },
  react: onReact,
  pub: onPub,   // 학교 모임의 서버 송출 공지
  sig(m) { AV.onSig(m.from, m.data); },
  sfu(m) { Sfu.onMsg(m); },
  full: onFull,
  close() { onClose(); Sfu.stop(); AV.reset(); },
};
